// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelDisabled-Icon_cls1__1RCfZ","cls2":"PaymentChannelDisabled-Icon_cls2__iTyjb PaymentChannelDisabled-Icon_cls1__1RCfZ"};